/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskGetJobCommentsPathParameters } from 'api/actions/helpdesk-get-job-comments/helpdesk-get-job-comments-path-parameters';
import { HelpdeskGetJobCommentsResponse } from 'api/actions/helpdesk-get-job-comments/helpdesk-get-job-comments-response';

type HelpdeskGetJobCommentsQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskGetJobComments action.
 */
export const helpdeskGetJobCommentsActionPath = new SweetPath<keyof HelpdeskGetJobCommentsPathParameters>(
  '/help-desk/jobs/{jobId}/comments',
  { path: '{param}' }
);

/**
 * Creates a contextualized HelpdeskGetJobComments actions.
 */
export default function createHelpdeskGetJobCommentsAction(axios: AxiosInstance) {
  return function helpdeskGetJobCommentsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HelpdeskGetJobCommentsPathParameters;
    query?: HelpdeskGetJobCommentsQueryParameters;
  }) {
    const path = helpdeskGetJobCommentsActionPath.insert(parameters);

    return axios.get<HelpdeskGetJobCommentsResponse, HelpdeskGetJobCommentsResponse>(path, { params: query, headers });
  };
}
